import * as React from "react";
import songCompassLogo from "../../assets/songCompassWhiteLogo.png";

export function SongCompassLogo() {
  return (
    <img id="songCompassLogo" src={songCompassLogo} alt={"Song Compass"} />
  );
}
